import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-empty-interface */
import { YPoint } from '../components/YPoint';
import { YPolygon } from '../components/YPolygon';
import { YLineString } from '../components/YLineString';
/** Возвращает id для геообъекта вставляемого в яндекс карту */
export var getMapPointId = function getMapPointId(id) {
  return "map-point-".concat(id);
};

/** Возвращает html для геообъекта вставляемого в яндекс карту */
export var getLayoutFactoryClass = function getLayoutFactoryClass(instance, _ref) {
  var _ref$options = _ref.options,
    html = _ref$options.html,
    id = _ref$options.id;
  var pointId = getMapPointId(id);
  return instance.templateLayoutFactory.createClass("<div id=\"".concat(pointId, "\">").concat(html, "</div>"));
};

/** Преобразует наш объект настроек геообъекта в формат яндекса */
export var mapGeoObjectsToYGeoObjects = function mapGeoObjectsToYGeoObjects(instance, points) {
  return points.map(function (point) {
    var options = point.options,
      type = point.type,
      name = point.name;
    switch (type) {
      case 'Point':
        {
          var yPoint = new YPoint(_objectSpread(_objectSpread({}, options), {}, {
            name: name,
            height: options.height,
            width: options.width,
            geometry: options.pointGeometry,
            coordinates: options.coordinates,
            component: getLayoutFactoryClass(instance, point)
          }));
          return yPoint.getOptions();
        }
      case 'Polygon':
        {
          var yPolygon = new YPolygon(_objectSpread(_objectSpread({}, options), {}, {
            name: name,
            coordinates: options.coordinates
          }));
          return yPolygon.getOptions();
        }
      case 'LineString':
        {
          var yLineString = new YLineString(_objectSpread(_objectSpread({}, options), {}, {
            name: name,
            coordinates: options.coordinates
          }));
          return yLineString.getOptions();
        }
    }
  });
};